// src/utils/languageUtils.js

import { LNG_DEFAULT } from "@/utils/constants";
import { startTransition } from "react";

// Define the languages constants directly in this file
const LanguesFR = ["fr-BE", "fr-FR", "fr", "fr-CA", "fr-CH", "fr-LU", "fr-MC"];
const LanguesNL = ["nl-BE", "nl-NL", "nl", "nl-AW", "nl-BQ", "nl-CW", "nl-SX"];
const LanguesEN = ["en-US", "en-GB", "en", "en-AU", "en-CA", "en-NZ", "en-IE"];

// Use a variable to track if determineLang has been called
let determineLangCalled = false;
let determinedLang = null;

export const getLangFromPath = (pathname) => {
  // Strip query string and hash: en SSR on reçoit l'URL complète (ex. /belgique?utm_source=…),
  // et sans ça le segment de langue ne matche plus → fallback NL sur une page FR.
  const urlArray = pathname.split(/[?#]/)[0].split("/");
  const urlLang = urlArray[1];
  
  if (urlLang === "belgie") {
    return "nl-BE";
  } else if (urlLang === "belgique") {
    return "fr-BE";
  }
  return null;
}

export const determineLang = (ssrLang = null) => {
  // Check if it has already been called
  if (determineLangCalled) {
    return determinedLang;
  }

  // Allow SSR override
  if (ssrLang) return ssrLang;

  if (typeof window === "undefined") {
    return LNG_DEFAULT;
  }

  const urlLang = getLangFromPath(window.location.pathname);

  const localStorageLang = localStorage.getItem("USERLANG");
  //console.log("🚀 ~ start determineLang", localStorageLang, urlLang);
  // Determine the language
  let lang;
  if (urlLang) {
    lang = urlLang;
  } else {
    lang =
      localStorageLang ||
      navigator.language?.split("-")[0] ||
      navigator.userLanguage?.split("-")[0] ||
      LNG_DEFAULT;
  }

  // Set the flag to true and store the determined language
  determineLangCalled = true;
  determinedLang = lang;
  //console.log("🚀 ~ end determineLang ~ determinedLang:", determinedLang);
  return determinedLang;
};

export const resetDetermineLang = () => {
  determineLangCalled = false;
  determinedLang = null;
};

export const changeAppLanguage = async (
  langStore,
  setLang,
  setProperties,
  setRouteMap
) => {
  resetDetermineLang();

  let folderLang = "nl-BE";
  if (LanguesFR.includes(langStore)) {
    folderLang = "fr-BE";
  } else if (LanguesNL.includes(langStore)) {
    folderLang = "nl-BE";
  } else if (LanguesEN.includes(langStore)) {
    folderLang = "nl-BE";
  }

  // Fetch all three files in parallel
  const [textJson, propsJson, routeJson] = await Promise.all([
    fetch(`/static/${folderLang}/text.json`).then((r) => r.ok ? r.json() : null).catch(() => null),
    fetch(`/static/${folderLang}/properties.json`).then((r) => r.ok ? r.json() : null).catch(() => null),
    fetch(`/static/${folderLang}/route.json`).then((r) => r.ok ? r.json() : null).catch(() => null),
  ]);

  startTransition(() => {
    if (textJson)  setLang(textJson);
    if (propsJson) setProperties(propsJson);
    if (routeJson) setRouteMap(routeJson);
  });

  if (typeof document !== 'undefined') {
    document.documentElement.lang = folderLang;
  }

  localStorage.setItem("USERLANG", langStore);
  localStorage.setItem("USERFOLDERLANG", folderLang);
};
